module.exports = __webpack_public_path__ + "static/media/tone4_good.31103122.svg";